import{createStorageHook as t}from"./storage";const{Storage:o,StorageContext:e,useStorage:a,withStorage:r}=t("localStorage");var c=o;export{o as LocalStorage,e as LocalStorageContext,c as default,a as useLocalStorage,r as withLocalStorage};
//# sourceMappingURL=use-local-storage.js.map
